import { IconButton, Typography } from '@mui/material';
import { treeItemClasses } from '@mui/lab/TreeItem';
import styled, { css } from 'styled-components';

import {
  Code as OrganizationCode,
  Name as OrganizationName,
  TreeItem as OrganizationTreeItem,
} from 'app/definitions/organization/organizationItem/OrganizationItem.styles';
import {
  PRESENCE_ACTION_COLUMN,
  PRESENCE_CODE_COLUMN_WIDTH,
  PRESENCE_COUNTERS_COLUMNS,
  PRESENCE_TREE_INDENT,
} from '../CurrentPresence.variables';

export const TreeItem = styled(OrganizationTreeItem)(
  ({ theme: { palette } }) => css`
    margin: 6px 0 0;

    & .${treeItemClasses.content} {
      min-height: 44px;
      padding: 4px 8px;
      border-radius: 6px;
      color: ${palette.text.primary};
      cursor: default;

      /* Rows are display-only: only the arrow and the presence icon react to the pointer. */
      &:hover,
      &.Mui-focused,
      &.Mui-selected,
      &.Mui-selected:hover,
      &.Mui-selected.Mui-focused {
        background-color: ${palette.common.white};
        border-color: ${palette.common.white};
      }
    }

    & .${treeItemClasses.iconContainer} svg {
      cursor: pointer;
    }

    & .${treeItemClasses.group} {
      margin-left: ${PRESENCE_TREE_INDENT}px;
    }
  `,
);

export const LabelWrapper = styled.div<{ $nameAreaWidth: number }>(
  ({ $nameAreaWidth }) => css`
    display: grid;
    grid-template-columns: ${$nameAreaWidth}px ${PRESENCE_COUNTERS_COLUMNS} 1fr ${PRESENCE_ACTION_COLUMN};
    align-items: center;
  `,
);

export const TextWrapper = styled.div`
  display: grid;
  grid-template-columns: ${PRESENCE_CODE_COLUMN_WIDTH}px 1fr;
  min-width: 0;
`;

/** KOD / NAZWA look exactly like Definicje → Strefy. */
export const Code = OrganizationCode;

export const Name = styled(OrganizationName)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Counter = styled(Typography)`
  font-size: 14px;
  padding-left: 15px;
`;

export const ActionWrapper = styled.span`
  display: inline-flex;
  grid-column: 7;
  justify-self: end;
`;

export const ShowOwnersButton = styled(IconButton)(
  ({ theme: { palette } }) => css`
    width: 32px;
    height: 32px;
    border-radius: 8px;
    padding: 0;
    background-color: ${palette.grey[200]};

    &:hover {
      background-color: ${palette.grey[300]};
    }
  `,
);
